var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preview-dialog" }, [
    _vm.emails.length === 2
      ? _c("div", { staticClass: "tabs" }, [
          _c(
            "button",
            {
              staticClass: "tab",
              class: { active: _vm.index === 0 },
              on: {
                click: function ($event) {
                  _vm.index = 0
                },
              },
            },
            [_vm._v(" Before Due Date ")]
          ),
          _c(
            "button",
            {
              staticClass: "tab",
              class: { active: _vm.index === 1 },
              on: {
                click: function ($event) {
                  _vm.index = 1
                },
              },
            },
            [_vm._v(" After Due Date ")]
          ),
        ])
      : _vm._e(),
    _c("div", {
      staticClass: "col",
      domProps: { innerHTML: _vm._s(_vm.htmlEmail) },
    }),
    _c(
      "i",
      {
        staticClass: "material-icons close",
        on: {
          click: function ($event) {
            return _vm.$emit("hide")
          },
        },
      },
      [_vm._v(" close ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }